export default "__VITE_ASSET__50218531__"